// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width {
   width: 100%;
}

.error {
   color: #E6261F;
   margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/allow-client/allow-client-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,WAAW;AACd;;AAEA;GACG,cAAc;GACd,eAAe;AAClB","sourcesContent":[".full-width {\n   width: 100%;\n}\n\n.error {\n   color: #E6261F;\n   margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
